import React from "react";
import EsgOrgPage from "../EsgOrgPage";

const OnboardingPage = () => {
  return <EsgOrgPage isOnboarding />;
};

export default OnboardingPage;
